import { createUseStyles } from 'react-jss';

export const simpleModalStyles = createUseStyles({
  container: {

  },
});
